import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  constructor(private api: ApiService) { }

  getAllAppointmentWithCount(data:any): Observable<any> {
    return this.api.post(environment.getAllAppointmentWithCount,data);
  }
  
  getPatient(data:any): Observable<any> {
    return this.api.post(environment.getPatient,data);
  }

  getAllAppointment(data:any): Observable<any> {
    return this.api.post(environment.getAllAppointment,data);
  }
  getAllAppointmentByPatientId(data:any): Observable<any> {
    return this.api.post(environment.getAllAppointmentByPatientId,data);
  }
  getAllSchedule(data:any): Observable<any> {
    return this.api.post(environment.getAllSchedule,data);
  }
  getSchedule(data:any): Observable<any> {
    return this.api.post(environment.getSchedule,data);
  }
  getAvailableDays(data:any): Observable<any> {
    return this.api.post(environment.getAvailableDays,data);
  }
  getSlots(data:any): Observable<any> {
    return this.api.post(environment.getSlots,data);
  }
  
  createAppointment(data:any): Observable<any> {
    return this.api.post(environment.createAppointment,data);
  }
  updateAppointment(data:any): Observable<any> {
    return this.api.post(environment.updateAppointment,data);
  }

  
  
  getDepartments(data:any): Observable<any> {
    return this.api.post(environment.getAllDepartment,data);
  }

  getUsersByDepartments(data:any): Observable<any> {
    return this.api.post(environment.getUserByDepartment,data);
  }

  checkInOpdPatientData(data:any): Observable<any> {
    return this.api.post(environment.checkInOpdPatientData,data);
  }

  getUserByDepartmentSchedule(data:any): Observable<any> {
    return this.api.post(environment.getUserByDepartmentSchedule,data);
  }

  // importAppointments(data:any): Observable<any> {
  //   //return this.api.post(environment.importAppointments,data);
  // }
  
  
}


